import React, { useContext } from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { AccordionContext, AccordionEvent } from './AccordionContext';

export interface AccordionButtonType
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    Omit<DefaultBsComponent, 'children' | 'tabIndex'> {}

export const AccordionButton = ({
  className,
  as: Component = 'div',
  children,
  ...props
}: AccordionButtonType) => {
  const { onClick, setOpen, open, index, question } =
    useContext(AccordionContext);

  const handleClick = (e: AccordionEvent) => {
    onClick && onClick(e, { open: !open, index, question });
    setOpen(!open);
  };

  const handleKeyDown = (e: AccordionEvent) => {
    if (e instanceof KeyboardEvent && e.key === 'Enter') {
      onClick && onClick(e, { open: !open, index, question });
      setOpen(!open);
    }
  };

  return (
    <button
      {...props}
      className={classNames(
        'AccordionTitle',
        'w-full relative flex',
        'transition duration-200 md:items-center',
        className,
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {children}
    </button>
  );
};
